export default () => {
  'ngInject';
  const pattern = '[size]';

  return (input, size = '160') => {
    return angular.isString(input) ? input.replace(pattern, size) : input;
  };
};



// WEBPACK FOOTER //
// src/app/common/filters/image-size.filter.ts